export const teamEventsParams = [
  {
    actions: [
      {
        id: 13,
        lexic_id: 326,
        title: 'On-Ball Events',
      },
      {
        id: 14,
        lexic_id: 550,
        title: 'On-Ball Events +',
      },
      {
        id: 16,
        lexic_id: 552,
        title: 'On-Ball Events -',
      },
      {
        id: 18,
        lexic_id: 328,
        title: 'Fouls',
      },
      {
        id: 19,
        lexic_id: 554,
        title: 'Fouls Suffered',
      },
      {
        id: 20,
        lexic_id: 104,
        title: 'Yellow Cards',
      },
      {
        id: 21,
        lexic_id: 555,
        title: 'Yellow-Red Cards',
      },
      {
        id: 22,
        lexic_id: 103,
        title: 'Red Cards',
      },
      {
        id: 145,
        lexic_id: 333,
        title: 'Offsides',
      },
      {
        id: 143,
        lexic_id: 324,
        title: 'Goal Mistakes',
      },
      {
        id: 144,
        lexic_id: 556,
        title: 'Grave Mistakes',
      },
    ],
    id: 1,
    lexic_id: 549,
    title: 'General',
  },
  {
    actions: [
      {
        id: 1,
        lexic_id: 558,
        title: 'Goals +',
      },
      {
        id: 2,
        lexic_id: 716,
        title: 'Goals -',
      },
      {
        id: 3,
        lexic_id: 715,
        title: 'Goal Chance',
      },
      {
        id: 4,
        lexic_id: 717,
        title: 'Goal Chance +',
      },
      {
        id: 6,
        lexic_id: 718,
        title: 'Goal Chance -',
      },
      {
        id: 8,
        lexic_id: 719,
        title: 'Goal Chance Allowed',
      },
      {
        id: 9,
        lexic_id: 720,
        title: 'Goal Chance Allowed +',
      },
      {
        id: 11,
        lexic_id: 721,
        title: 'Goal Chance Allowed -',
      },
      {
        id: 23,
        lexic_id: 18,
        title: 'Shots',
      },
      {
        id: 24,
        lexic_id: 462,
        title: 'Shots on Target',
      },
      {
        id: 26,
        lexic_id: 570,
        title: 'Shots Wide',
      },
      {
        id: 28,
        lexic_id: 572,
        title: 'Shots Blocked',
      },
      {
        id: 30,
        lexic_id: 574,
        title: 'Shots on Post or Bar',
      },
      {
        id: 32,
        lexic_id: 576,
        title: 'Shots from Free kick',
      },
    ],
    id: 2,
    lexic_id: 557,
    title: 'Goals/Chances/Shots',
  },
  {
    actions: [
      {
        id: 34,
        lexic_id: 19,
        title: 'Passes',
      },
      {
        id: 35,
        lexic_id: 578,
        title: 'Passes +',
      },
      {
        id: 37,
        lexic_id: 580,
        title: 'Passes -',
      },
      {
        id: 39,
        lexic_id: 722,
        title: 'Passes into duel',
      },
      {
        id: 40,
        lexic_id: 723,
        title: 'Passes into duel +',
      },
      {
        id: 42,
        lexic_id: 724,
        title: 'Passes into duel -',
      },
      {
        id: 49,
        lexic_id: 587,
        title: 'Crosses',
      },
      {
        id: 50,
        lexic_id: 588,
        title: 'Crosses +',
      },
      {
        id: 52,
        lexic_id: 590,
        title: 'Crosses -',
      },
    ],
    id: 3,
    lexic_id: 19,
    title: 'Passes',
  },
  {
    actions: [
      {
        id: 54,
        lexic_id: 664,
        title: 'Short Passes',
      },
      {
        id: 55,
        lexic_id: 665,
        title: 'Short Passes +',
      },
      {
        id: 57,
        lexic_id: 667,
        title: 'Short Passes -',
      },
      {
        id: 59,
        lexic_id: 669,
        title: 'Medium Passes',
      },
      {
        id: 60,
        lexic_id: 670,
        title: 'Medium Passes +',
      },
      {
        id: 62,
        lexic_id: 672,
        title: 'Medium Passes -',
      },
      {
        id: 64,
        lexic_id: 674,
        title: 'Long Passes',
      },
      {
        id: 65,
        lexic_id: 675,
        title: 'Long Passes +',
      },
      {
        id: 67,
        lexic_id: 677,
        title: 'Long Passes -',
      },
    ],
    id: 4,
    lexic_id: 663,
    title: 'Passes by distance',
  },
  {
    actions: [
      {
        id: 69,
        lexic_id: 685,
        title: 'Passes Onward',
      },
      {
        id: 70,
        lexic_id: 686,
        title: 'Passes Onward +',
      },
      {
        id: 72,
        lexic_id: 688,
        title: 'Passes Onward -',
      },
      {
        id: 74,
        lexic_id: 690,
        title: 'Passes Rearward',
      },
      {
        id: 75,
        lexic_id: 691,
        title: 'Passes Rearward +',
      },
      {
        id: 77,
        lexic_id: 693,
        title: 'Passes Rearward -',
      },
      {
        id: 79,
        lexic_id: 695,
        title: 'Passes Sideways',
      },
      {
        id: 80,
        lexic_id: 696,
        title: 'Passes Sideways +',
      },
      {
        id: 82,
        lexic_id: 698,
        title: 'Passes Sideways -',
      },
    ],
    id: 5,
    lexic_id: 706,
    title: 'Passes by side',
  },
  {
    actions: [
      {
        id: 44,
        lexic_id: 330,
        title: 'Key Passes',
      },
      {
        id: 45,
        lexic_id: 598,
        title: 'Key Passes +',
      },
      {
        id: 47,
        lexic_id: 600,
        title: 'Key Passes -',
      },
      {
        id: 84,
        lexic_id: 602,
        title: 'Progressive Passes',
      },
      {
        id: 85,
        lexic_id: 603,
        title: 'Progressive Passes +',
      },
      {
        id: 87,
        lexic_id: 605,
        title: 'Progressive Passes -',
      },
    ],
    id: 6,
    lexic_id: 597,
    title: 'Advanced passes',
  },
  {
    actions: [
      {
        id: 100,
        lexic_id: 20,
        title: 'Duels',
      },
      {
        id: 101,
        lexic_id: 611,
        title: 'Duels +',
      },
      {
        id: 103,
        lexic_id: 613,
        title: 'Duels -',
      },
      {
        id: 105,
        lexic_id: 331,
        title: 'Aerial Duels',
      },
      {
        id: 106,
        lexic_id: 615,
        title: 'Aerial Duels +',
      },
      {
        id: 108,
        lexic_id: 617,
        title: 'Aerial Duels -',
      },
      {
        id: 110,
        lexic_id: 619,
        title: 'Duels in Offence',
      },
      {
        id: 111,
        lexic_id: 620,
        title: 'Duels in Offence +',
      },
      {
        id: 113,
        lexic_id: 622,
        title: 'Duels in Offence -',
      },
      {
        id: 115,
        lexic_id: 624,
        title: 'Duels in Defence',
      },
      {
        id: 116,
        lexic_id: 625,
        title: 'Duels in Defence +',
      },
      {
        id: 118,
        lexic_id: 627,
        title: 'Duels in Defence -',
      },
    ],
    id: 7,
    lexic_id: 20,
    title: 'Duels',
  },
  {
    actions: [
      {
        id: 120,
        lexic_id: 630,
        title: 'Tackles Made',
      },
      {
        id: 121,
        lexic_id: 631,
        title: 'Tackles Made +',
      },
      {
        id: 123,
        lexic_id: 633,
        title: 'Tackles Made -',
      },
      {
        id: 130,
        lexic_id: 635,
        title: 'Interceptions',
      },
      {
        id: 131,
        lexic_id: 636,
        title: 'Interceptions +',
      },
      {
        id: 133,
        lexic_id: 638,
        title: 'Interceptions -',
      },
      {
        id: 142,
        lexic_id: 641,
        title: 'Clearances',
      },
      {
        id: 135,
        lexic_id: 640,
        title: 'Blocked shots',
      },
      {
        id: 95,
        lexic_id: 642,
        title: 'Dribbles Faced',
      },
      {
        id: 96,
        lexic_id: 643,
        title: 'Dribbles Faced +',
      },
      {
        id: 98,
        lexic_id: 645,
        title: 'Dribbles Faced -',
      },
    ],
    id: 8,
    lexic_id: 629,
    title: 'In defence',
  },
  {
    actions: [
      {
        id: 90,
        lexic_id: 648,
        title: 'Dribbles Made',
      },
      {
        id: 91,
        lexic_id: 649,
        title: 'Dribbles Made +',
      },
      {
        id: 93,
        lexic_id: 651,
        title: 'Dribbles Made -',
      },
      {
        id: 89,
        lexic_id: 653,
        title: 'Progressive Carries',
      },
      {
        id: 125,
        lexic_id: 654,
        title: 'Tackles Faced',
      },
      {
        id: 126,
        lexic_id: 655,
        title: 'Tackles Faced +',
      },
      {
        id: 128,
        lexic_id: 657,
        title: 'Tackles Faced -',
      },
    ],
    id: 10,
    lexic_id: 647,
    title: 'In offence',
  },
  {
    actions: [
      {
        id: 136,
        lexic_id: 337,
        title: 'Ball Recoveries',
      },
      {
        id: 137,
        lexic_id: 726,
        title: 'Ball Recoveries within 5 seconds',
      },
      {
        id: 138,
        lexic_id: 727,
        title: 'Ball Recoveries within 10 seconds',
      },
      {
        id: 139,
        lexic_id: 336,
        title: 'Ball Losses',
      },
      {
        id: 149,
        lexic_id: 728,
        title: 'Ball Losses within 5 seconds',
      },
      {
        id: 141,
        lexic_id: 729,
        title: 'Ball Losses within 10 seconds',
      },
    ],
    id: 11,
    lexic_id: 431,
    title: 'Ball possession',
  },
  {
    actions: [
      {
        id: 146,
        lexic_id: 461,
        title: 'Corners',
      },
      {
        id: 147,
        lexic_id: 731,
        title: 'Free kicks',
      },
      {
        id: 148,
        lexic_id: 732,
        title: 'Throw-ins',
      },
      {
        id: 149,
        lexic_id: 733,
        title: 'Indirect Free Kicks',
      },
      {
        id: 150,
        lexic_id: 734,
        title: 'Goal Kicks',
      },
    ],
    id: 12,
    lexic_id: 730,
    title: 'Set pieces',
  },
  // {
  //   actions: [
  //     {
  //       id: 160,
  //       lexic_id: 736,
  //       title: 'Attacks , all',
  //     },
  //     {
  //       id: 161,
  //       lexic_id: 737,
  //       title: 'Attacks - left wing',
  //     },
  //     {
  //       id: 162,
  //       lexic_id: 738,
  //       title: 'Attacks with shots - left wing',
  //     },
  //     {
  //       id: 164,
  //       lexic_id: 739,
  //       title: 'Attacks - center',
  //     },
  //     {
  //       id: 165,
  //       lexic_id: 740,
  //       title: 'Attacks with shots - center',
  //     },
  //     {
  //       id: 167,
  //       lexic_id: 741,
  //       title: 'Attacks - right wing',
  //     },
  //     {
  //       id: 168,
  //       lexic_id: 742,
  //       title: 'Attacks with shots - right wing',
  //     },
  //     {
  //       id: 170,
  //       lexic_id: 743,
  //       title: 'Positional attacks',
  //     },
  //     {
  //       id: 171,
  //       lexic_id: 744,
  //       title: 'Positional attacks with shots',
  //     },
  //     {
  //       id: 173,
  //       lexic_id: 745,
  //       title: 'Quick attacks',
  //     },
  //     {
  //       id: 174,
  //       lexic_id: 746,
  //       title: 'Quick attacks with shots',
  //     },
  //     {
  //       id: 176,
  //       lexic_id: 747,
  //       title: 'Set piece attacks',
  //     },
  //     {
  //       id: 177,
  //       lexic_id: 748,
  //       title: 'Set piece attacks with shots',
  //     },
  //     {
  //       id: 179,
  //       lexic_id: 749,
  //       title: 'Free kick attacks',
  //     },
  //     {
  //       id: 180,
  //       lexic_id: 750,
  //       title: 'Free kick attacks with shots',
  //     },
  //     {
  //       id: 182,
  //       lexic_id: 751,
  //       title: 'Corner attacks',
  //     },
  //     {
  //       id: 183,
  //       lexic_id: 752,
  //       title: 'Corner attacks with shots',
  //     },
  //     {
  //       id: 185,
  //       lexic_id: 753,
  //       title: 'Throw-in attacks',
  //     },
  //     {
  //       id: 186,
  //       lexic_id: 754,
  //       title: 'Throw-in attacks with shots',
  //     },
  //     {
  //       id: 188,
  //       lexic_id: 755,
  //       title: 'Free kick attacks with goals',
  //     },
  //     {
  //       id: 190,
  //       lexic_id: 756,
  //       title: 'Penalties',
  //     },
  //     {
  //       id: 191,
  //       lexic_id: 757,
  //       title: 'Penalties scored',
  //     },
  //     {
  //       id: 193,
  //       lexic_id: 758,
  //       title: 'Wing Attacks',
  //     },
  //     {
  //       id: 194,
  //       lexic_id: 759,
  //       title: 'Wing Attacks with shots',
  //     },
  //     {
  //       id: 196,
  //       lexic_id: 760,
  //       title: 'Counter-attacks',
  //     },
  //     {
  //       id: 197,
  //       lexic_id: 761,
  //       title: 'Counter-attacks with a shot',
  //     },
  //     {
  //       id: 199,
  //       lexic_id: 762,
  //       title: 'Counter-pressing attacks',
  //     },
  //     {
  //       id: 200,
  //       lexic_id: 763,
  //       title: 'Counter-pressing attacks with shots',
  //     },
  //     {
  //       id: 202,
  //       lexic_id: 764,
  //       title: 'Long ball attacks',
  //     },
  //     {
  //       id: 203,
  //       lexic_id: 725,
  //       title: 'Long ball attacks with shots',
  //     },
  //   ],
  //   id: 13,
  //   lexic_id: 735,
  //   title: 'Attack types',
  // },
];
